import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NewCTEDueDateService } from "./new-cte-due-date.service";
import { DATE_FORMAT_REGEX } from "app/shared/constants/date-format-regex.constant";
import moment from "moment";

@Component({
    selector: "NewCTEDueDate",
    templateUrl: "./new-cte-due-date.component.html",
})
export class NewCTEDueDateComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { payableId: number },
        private readonly snack: MatSnackBar,
        private readonly formBuilder: FormBuilder,
        private readonly dueDateService: NewCTEDueDateService,
    ) {
        this.payableId = data.payableId;
    }

    public dueDateform: FormGroup;
    public payableId: number;
    minDate = new Date();

    @Output() cteUpdatedEmitter = new EventEmitter<{ id: number; dtVencimento: string }>();
    @Output() closeEmitter = new EventEmitter<void>();

    ngOnInit(): void {
        this.dueDateform = this.formBuilder.group({
            dueDate: ["", [Validators.required]],
        });
    }

    async updateCteDueDate() {
        try {
            const dueDate = this.dueDateform.value.dueDate as string | Date;
            const dueDateFormatted = DATE_FORMAT_REGEX.test(dueDate as string)
                ? String(dueDate).split("/").reverse().join("-")
                : dueDate;
            console.log({ dueDateFormatted });
            const res = await this.dueDateService.updatePayableDueDate({
                date: moment(dueDateFormatted).format("YYYY-MM-DDT23:59:59"),
                payableId: this.payableId,
            });

            if (res.dtVencimento) {
                this.snack.open("Vencimento alterado com sucesso", "Fechar", {
                    duration: 3000,
                    panelClass: ["snack-bar-success"],
                });

                const { id, dtVencimento }: { id: number; dtVencimento: string } = res;
                const standardDate: string = dtVencimento.split("T")[0].split("-").reverse().join("/");

                this.cteUpdatedEmitter.emit({ dtVencimento: standardDate, id });
            }
        } catch (error) {
            console.log(error);
            this.snack.open("Erro ao definir o vencimento", "Fechar", {
                duration: 3000,
                panelClass: ["snack-bar-error"],
            });
        }
    }

    cancel() {
        this.closeEmitter.emit();
    }
}
function adjustDateToEndOfDay(arg0: string): import("moment").MomentInput {
    throw new Error("Function not implemented.");
}
